export default __webpack_public_path__ + "static/media/account.16c30c83.svg";